export default "__VITE_PUBLIC_ASSET__79bc3610__"